import api from './api';

const API_URL = '/auth';

export const getMe = async () => {
  const response = await api.get(`${API_URL}/me`, { skipLoader: true });
  return response.data;
};

export const changePassword = async (data) => {
  const response = await api.put(
    `${API_URL}/change-password`,
    {
      userId: data.userId,
      oldPassword: data.oldPassword || data.currentPassword,
      newPassword: data.newPassword,
    },
    { skipLoader: true },
  );
  return response.data;
};

export const requestPasswordReset = async (data) => {
  const response = await api.post(`${API_URL}/password-reset/request`, data);
  return response.data;
};

export const verifyRecoveryCode = async (data) => {
  const response = await api.post(`${API_URL}/password-reset/verify`, data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await api.post(`${API_URL}/password-reset/reset`, data);
  return response.data;
};

export const login = async (credentials) => {
  const response = await api.post(`${API_URL}/login`, credentials);
  return response.data;
};

export const loginWithDNI = async (credentials) => {
  const response = await api.post(`${API_URL}/login/dni`, credentials);
  return response.data;
};
